<template>
  <li v-if="!noPermissions" class="nav-group" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-group-title" @click="toggled = !toggled" id="curriculum-button" :aria-expanded="toggled" aria-controls="curriculum-expanded">
      <i class="k-asset-icon fa-duotone fa-building-columns" aria-hidden="true"></i><span>Curriculum</span>
      <i class="fas fa-angle-down" aria-hidden="true"></i>
    </button>
    <ul class="second-level" id="curriculum-expanded" aria-labelledby="curriculum-button" :hidden="!toggled">
      <blueprints-dropdown v-if="$permissions.hasPermission('manage_blueprints')"></blueprints-dropdown>
      <assets-dropdown v-if="$permissions.hasPermission('manage_assets')" class="nav-group"></assets-dropdown>
    </ul>
  </li>
</template>

<style scoped>
.nav-group {
  list-style: none;
}
</style>

<script>
import SidebarEntryMixin from '@mixins/sidebar-entry-mixin';
import BlueprintsDropdown from './blueprints-dropdown.vue';
import AssetsDropdown from './assets-dropdown.vue';

const REQUIRED_PERMS = [
  'manage_blueprints',
  'manage_assets',
];

export default {
  mixins: [SidebarEntryMixin],

  components: {
    BlueprintsDropdown,
    AssetsDropdown,
  },

  data() {
    return {
      toggled: false,
    };
  },

  computed: {
    isVisible() {
      return !this.noPermissions;
    },

    noPermissions() {
      for (let i = 0; i < REQUIRED_PERMS.length; i++) {
        if (this.$permissions.hasPermission(REQUIRED_PERMS[i])) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
